import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import { HttpParams } from '@angular/common/http';
import { ListaAlteracaoStatusService } from './lista-alteracao-status.service';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-lista-alteracao-status',
  templateUrl: './lista-alteracao-status.component.html',
  styleUrls: ['./lista-alteracao-status.component.scss']
})
export class ListaAlteracaoStatusComponent implements OnInit {

  @ViewChild('myTable', { static: false }) table: any;

  public spinnerLoad: boolean = false;
  public formListaStatus = null;
  public listStatus = null;
  public rowData: any;
  public yesterday = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
  public customLogin = null;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    disableUntil: { year: this.yesterday.getFullYear(), month: this.yesterday.getMonth() + 1, day: this.yesterday.getDate() },

  };

  constructor(
    private formBuilder: FormBuilder,
    private ListaAlteracaoStatusService: ListaAlteracaoStatusService,
    private service: ListaAlteracaoStatusService,
    private encriptyService: EncriptyUtilService,
    private notifications: NotificationsService,
    private router: Router,
  ) {

    this.rowData = [];

    this.listStatus = [

      {
        status: 'ATIVO',
        novoStatus: 'ATIVO'
      },

      {
        status: 'BLOQUEADO',
        novoStatus: 'BLOQUEADO'
      },

      {
        status: 'SUSPENSO',
        novoStatus: 'SUSPENSO'
      },

    ];

    this.formListaStatus = this.formBuilder.group({
      cpf: [null],
      matricula: [null],
      novoStatus: [null],
      dataAgendado: [null],
    });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  buscarUser(data) {
    let params = new HttpParams();

    if (data.cpf != null) {
      params = params.append('cpf', data.cpf);

    }
    if (data.matricula != null) {
      params = params.append('matricula', data.matricula);
    }

    this.service.buscaUsuario(params, (response => {
      this.rowData = response
    }), (error) => {
      this.notifications.error(error.message);
    });
  }

  saveStatus() {

    let data = this.formListaStatus.value;
    if (data.dataAgendado != null) {
      let dataAgendado = this.getDateTimestamp(data.dataAgendado);
      data.dataAgendado = dataAgendado;
      data['dataAgendamento'] = dataAgendado;
    }
    let produtoFuncionarioIds = this.rowData.map(function (element) {
      return element.id;
    })
    data['ids'] = produtoFuncionarioIds;


    this.spinnerLoad = true
    this.service.saveAlterStatus(
      data,
      (resp) => {
        this.notifications.success('Registro Salvo com sucesso!');
        this.limparForm();
        this.spinnerLoad = false
      }, (error) => {
        this.spinnerLoad = false
        this.notifications.error(error.message);
      })

  }

  getDateTimestamp(data) {
    let dataReturn = null;
    if ('jsdate' in data) {
      dataReturn = new Date(data.jsdate)
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    } else {
      dataReturn = new Date(data.date['year'], data.date['month'] - 1, data.date['day']).getTime();
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    }

    return dataReturn;
  }

  limparForm() {
    this.formListaStatus = this.formBuilder.group({
      cpf: [null],
      matricula: [null],
      novoStatus: [null],
      dataAgendado: [null],
    });
    this.rowData = null;
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}

